var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCallBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1492 6.44035C14.9909 6.60425 15.7644 7.01511 16.3708 7.62033C16.9772 8.22556 17.3888 8.99761 17.5531 9.83769M14.1492 3C15.8979 3.19389 17.5286 3.97549 18.7735 5.21645C20.0184 6.45741 20.8035 8.08398 21 9.82909M20.1383 16.6926V19.2728C20.1392 19.5124 20.0901 19.7495 19.9939 19.969C19.8978 20.1884 19.7568 20.3854 19.5799 20.5474C19.4031 20.7093 19.1943 20.8326 18.967 20.9093C18.7396 20.9861 18.4987 21.0146 18.2597 20.993C15.608 20.7054 13.0608 19.8011 10.8229 18.3526C8.74082 17.032 6.97557 15.2701 5.65252 13.192C4.19617 10.9482 3.28985 8.3936 3.00699 5.73508C2.98546 5.49723 3.01378 5.25752 3.09015 5.0312C3.16652 4.80488 3.28927 4.59691 3.45059 4.42054C3.6119 4.24416 3.80824 4.10324 4.02711 4.00675C4.24598 3.91026 4.48258 3.86031 4.72185 3.86009H7.30705C7.72525 3.85598 8.13069 4.00379 8.44778 4.27597C8.76487 4.54815 8.97198 4.92612 9.03051 5.33944C9.13963 6.16518 9.34199 6.97595 9.63373 7.75628C9.74967 8.06413 9.77476 8.39869 9.70603 8.72034C9.63731 9.04198 9.47764 9.33722 9.24595 9.57106L8.15155 10.6634C9.37827 12.8166 11.1646 14.5995 13.322 15.8239L14.4164 14.7316C14.6506 14.5003 14.9465 14.341 15.2687 14.2724C15.591 14.2038 15.9262 14.2288 16.2346 14.3445C17.0164 14.6357 17.8288 14.8377 18.6561 14.9466C19.0747 15.0055 19.457 15.216 19.7303 15.5379C20.0035 15.8598 20.1488 16.2708 20.1383 16.6926Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallBlack);
export default __webpack_public_path__ + "static/media/phone-call_black.f7837d8cec41958296f7cc47a5b4cfdf.svg";
export { ForwardRef as ReactComponent };